import * as React from "react"

const LineColor3 = React.forwardRef((props, pathRef) => {
        return (
            <svg
                width={2}
                height={120}
                fill="none"
                xmlns="http://www.w3.org/2000/svg"
                viewBox={`0 0 2 120`}


            >
                <path
                    id={"line-color-3"}

                    ref={pathRef}


                    d="M0 0V120H2V0H0Z" fill="#560BAD"
                    strokeDashoffset={props.normalizedPosition }
                    strokeDasharray={props.pathLength}
                />
            </svg>
        )
    }
)

export default LineColor3
